import * as types from "./types";

export const actionChangeDataShoppingCart = (name, value) => ({
    type: types.CHANGE_DATA_SHOPPING_CART, name, value
});
